import { Injectable }          from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth }     from 'angularfire2/auth';
import * as firebase from 'firebase';
import { Http, Response,Headers } from '@angular/http';

import 'rxjs/add/operator/take';
import { BehaviorSubject } from 'rxjs/BehaviorSubject'

@Injectable()
export class MessagingService {

  messaging = firebase.messaging()
  currentMessage = new BehaviorSubject(null)
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(private db: AngularFireDatabase, private afAuth: AngularFireAuth,  private http: Http) { }


  updateToken(token) {
    this.afAuth.authState.take(1).subscribe(user => {
      if (!user) return;

      const data = { [user.uid]: token }
      this.db.object('fcmTokens/').update(data)
    })
  }

  getPermission(url) {
      this.messaging.requestPermission()
      .then(() => {
        //console.log('Notification permission granted.');
        return this.messaging.getToken()
      })
      .then(token => {
        //console.log(token)
        this.http.get(url+'http/update/user/fcm_token?fcm_token='+token,{ headers: this.headers })
  
    .subscribe(data => {
   
    });
        this.updateToken(token)
      })
      .catch((err) => {
       // console.log('Unable to get permission to notify.', err);
      });
    }

    receiveMessage() {
    	
       this.messaging.onMessage((payload) => {
        //console.log("Message received. ", payload);
        this.currentMessage.next(payload)
      });

    }
}


// WEBPACK FOOTER //
// ./src/app/messaging.service.ts